/**
 * Moves collection inline promotion and inline curations roots into `.wf-cg__injected-section`.
 * Hosts reference the movable root id via `data-wf-inline-promo-host` or `data-wf-inline-curations-host`.
 */
(function () {
  if (window.__wfCollectionInlinePromotionInit) return;
  window.__wfCollectionInlinePromotionInit = true;

  var SELECTOR_HOSTS =
    '[data-wf-inline-promo-host], [data-wf-inline-curations-host]';
  var SELECTOR_TARGET = '.wf-cg__injected-section';

  function teleportIdFromHost(el) {
    if (!el) return '';
    var id =
      el.getAttribute('data-wf-inline-promo-host') ||
      el.getAttribute('data-wf-inline-curations-host');
    return id || '';
  }

  function moveInlineIntoGrid(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var hosts =
      scope.querySelectorAll && scope.querySelectorAll(SELECTOR_HOSTS);

    if (!hosts.length) hosts = document.querySelectorAll(SELECTOR_HOSTS);
    if (!hosts.length) return;

    var target = document.querySelector(SELECTOR_TARGET);
    if (!target) return;

    for (var i = 0; i < hosts.length; i++) {
      var host = hosts[i];
      var teleportId = teleportIdFromHost(host);
      if (!teleportId) continue;

      var source = document.getElementById(teleportId);
      if (!source) continue;

      if (source.parentElement === target) continue;

      target.appendChild(source);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      moveInlineIntoGrid(document);
    });
  } else {
    moveInlineIntoGrid(document);
  }

  document.addEventListener('shopify:section:load', function () {
    moveInlineIntoGrid(document);
  });
})();
